import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserModule } from '@angular/platform-browser';
import { FooterModule } from '../../shared/shell/footer/footer.module';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { EmailVerificationScreenComponent } from './email-verification-screen/email-verification-screen.component';
import { LandingScreenComponent } from './landing-screen/landing-screen.component';
import { RegUpdateScreenComponent } from './reg-update-screen/reg-update-screen.component';
import { PipesModule } from '../../shared/pipes/pipes.module';
import { SelfServiceAcknowlagementScreenComponent } from './self-service-acknowlagement-screen/self-service-acknowlagement-screen.component';
import { SelfServiceExpiryScreenComponent } from './self-service-expiry-screen/self-service-expiry-screen.component';
import {
  RecaptchaV3Module,
  ReCaptchaV3Service,
  RECAPTCHA_V3_SITE_KEY,
} from 'ng-recaptcha';
import { ContactSelfServiceFormsService } from './contact-self-service-forms.service';
import { Observable } from 'rxjs';

export function getDetails(
  contactSelfServiceFormsService: ContactSelfServiceFormsService
): () => Observable<any> {
  return () => contactSelfServiceFormsService.getDomainAndSiteKey();
}
@NgModule({
  declarations: [
    LandingScreenComponent,
    EmailVerificationScreenComponent,
    RegUpdateScreenComponent,
    SelfServiceAcknowlagementScreenComponent,
    SelfServiceExpiryScreenComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    CommonModule,
    ReactiveFormsModule,
    FormlyModule.forChild(),
    TranslateModule.forChild(),
    MatIconModule,
    MatTabsModule,
    FooterModule,
    PipesModule,
    RecaptchaV3Module,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: getDetails,
      deps: [ContactSelfServiceFormsService],
      multi: true,
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: (contactSelfService: ContactSelfServiceFormsService) => {
        return contactSelfService.getSiteKey;
      },
      deps: [ContactSelfServiceFormsService],
    },
    {
      provide: 'TestRecaptchaService',
      useFactory: (
        contactSelfService: ContactSelfServiceFormsService,
        recaptchaV3Service: ReCaptchaV3Service
      ) => {
        return contactSelfService.getIsDomainNotAupr
          ? recaptchaV3Service
          : null;
      },
      deps: [ContactSelfServiceFormsService, ReCaptchaV3Service],
    },
  ],
})
export class ContactSelfServiceFormsModule {}
